<script setup lang="ts">
type Placement = 'top-start' | 'top' | 'top-end' | 'right-start' | 'right' | 'right-end' | 'bottom-start' | 'bottom' | 'bottom-end' | 'left-start' | 'left' | 'left-end'

withDefaults(defineProps<{
  placement?: Placement
  interactive?: boolean
}>(), {
  placement: 'bottom-start',
  interactive: false,
})

const isShown = ref(false)
</script>

<template>
  <ClientOnly>
    <Popper
      :placement="placement"
      offset-distance="8"
      :interactive="interactive"
      @open:popper="isShown = true"
      @close:popper="isShown = false"
    >
      <slot :is-shown="isShown" />

      <template #content="{ close }">
        <slot name="content" :close="close" />
      </template>
    </Popper>
  </ClientOnly>
</template>
